'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var ReturnsLayout = require('../Layout/ReturnsLayout.js');
var useReturns = require('../../hooks/useReturns.js');
var mapItem = require('../../transformers/mapItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ReasonsPage = () => {
  const {
    orderData,
    selectedItems,
    setSelectedItems
  } = useReturns["default"]();
  const navigate = reactRouterDom.useNavigate();
  const [orderItem, setOrderItem] = React.useState();
  const [selectedItem, setSelectedItem] = React.useState();
  const [searchParams] = reactRouterDom.useSearchParams();
  const sku = decodeURIComponent(searchParams.get('sku') || '');
  const itemId = decodeURIComponent(searchParams.get('itemId') || '');
  React.useEffect(() => {
    var _orderData$items;
    const orderItem = orderData === null || orderData === void 0 ? void 0 : (_orderData$items = orderData.items) === null || _orderData$items === void 0 ? void 0 : _orderData$items.find(item => {
      if (sku && itemId) return item.sku === sku && item.itemId === itemId;
      if (sku) return item.sku === sku;
      return item.itemId === itemId;
    });
    const selectedItem = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.find(item => {
      if (sku && itemId) return item.sku === sku && item.itemId === itemId;
      if (sku) return item.sku === sku;
      return item.itemId === itemId;
    });
    if (!orderItem) return;
    setOrderItem(orderItem);
    setSelectedItem(selectedItem);
  }, [orderData, selectedItems, sku, itemId]);

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  const handleSelectSubmit = async _ref => {
    let {
      value
      // TODO: refactor instead of disable
      // eslint-disable-next-line @typescript-eslint/require-await
    } = _ref;
    if (!value) return;
    const items = selectedItems || [];
    const newItems = [...items, mapItem["default"]({
      orderItem: value.item,
      quantity: value.quantity,
      selectedReason: value.selectedReason,
      customerComments: value.customerComments
    })];
    setSelectedItems === null || setSelectedItems === void 0 ? void 0 : setSelectedItems(newItems);
    navigate('/items');
  };

  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  const handleEditSubmit = async _ref2 => {
    let {
      value
      // TODO: refactor instead of disable
      // eslint-disable-next-line @typescript-eslint/require-await
    } = _ref2;
    if (!value) return;
    const items = selectedItems || [];
    const newItems = items.filter(item => item.sku !== value.item.sku && item.itemId !== value.item.itemId);
    if (value.quantity && value.quantity > 0) newItems.push(mapItem["default"]({
      orderItem: value.item,
      quantity: value.quantity,
      selectedReason: value.selectedReason,
      customerComments: value.customerComments
    }));
    setSelectedItems === null || setSelectedItems === void 0 ? void 0 : setSelectedItems(newItems);
    navigate('/items');
  };
  if (!orderItem) {
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(ReturnsLayout["default"], {
    returnReasons: {
      orderItem,
      selectedItem,
      onSubmit: selectedItem ? handleEditSubmit : handleSelectSubmit,
      onClose: () => {
        navigate('/items');
      }
    }
  });
};

exports["default"] = ReasonsPage;
